<template>
  <div class="">
    <div class="right">
      <!-- <div class="title">招生简章</div>
      <div class="info5">
        <p v-for="(item,index) in data.news" @click="goDetail1(item)">{{item.title}}</p>
      </div> -->
      <div class="title">同档院校</div>
      <div class="info6">
        <div class="info6-1 flex" v-for="(item,index) in data.similar" @click="goDetail(item)">
          <img :src='"https://yunzhixuanpro.fw366.cn/"+item.badge_img'>
          <div>
            <p>{{item.school_name}}</p>
            <p class="fenlei">
              <span>院校国际代码：{{item.short_code}}</span><span style="margin-left: 5px;">所在省份：{{item.province_name}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    props: {
      data: {
        type: Array,
        required: true,
      }
    },
    created() {

    },
    methods: {
      goDetail(item) {
        this.$router.push('/schoolDetail?id=' + item.id)
      },
      goDetail1(item) {
        this.$router.push('/Guide?id=' + item.id)
      },
    },
  }
</script>

<style scoped lang="scss">
  .right {
    margin-left: 20px;
  }

  .filter1 {
    width: 100%;
    text-align: left;
    margin-top: 30px;
  }

  .info6 {
    overflow: hidden;
    margin-top: 20px;
    margin-right: 10px;

    .fenlei {
      font-weight: 400;
      color: #19CACA;
      line-height: 30px;
      margin-top: 24px;
    }

    .info6-1 {
      margin: 15px 0 20px 23px;
      text-align: left;
    }

    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-right: 21px;
    }

    width: 420px;
    // height: 334px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
  }

  .info5 {
    width: 420px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin-top: 21px;
    margin-bottom: 54px;
    overflow: hidden;

    p {
      text-align: left;
      margin: 21px 0 21px 27px;
      cursor: pointer;
    }
  }

  .table2 {
    width: 716px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 11px;
    padding-bottom: 10px;
  }

  .line {
    width: 1px;
    height: 100%;
    background-color: #CCCCCC;
    min-height: 100px;
  }

  .tablemain {
    span {
      margin: 12px 23px 19px 25px;
    }
  }

  .table1 {
    min-height: 100px;
    // padding-bottom: 10px;
    margin-bottom: 10px;

    .tablename {
      height: 100%;
      width: 173px;

      p {
        width: 100%;
        text-align: center;
      }
    }

    width: 716px;
    // height: 260px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 21px 0 0 16px;
  }

  .info4 {
    overflow: hidden;
    margin-bottom: 39px;
    padding-bottom: 5px;

    &>div {
      width: 133px;
      height: 103px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      margin: 19px 0 0px 2px;
      margin-right: 21px;
    }

    .rank {
      color: #19CACA;
      margin-top: 17px;
      margin-bottom: 18px;

      span {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #19CACA;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ad.vue